// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotel-details-container {
   
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }
  
  .hotel-card {
    border: none;
    background-color: #daffcd; /* Light color for hotel card */
    border-radius: 10px;
    transition: transform 0.3s;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-size: 18px;
  }
  
  .hotel-card:hover {
    /* transform: scale(1.03); */
  }
  
  .hotel-title {
    color: #8b4513; /* Brown color for hotel title */
    font-weight: bold;
  }
  
  .room-card {
    border: none;
    background-color: #ffe4e1; /* Light pink color for room cards */
    border-radius: 10px;
    transition: transform 0.3s;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .room-card:hover {
    transform: scale(1.03);
  }
  
  h2 {
    color: #4682b4; /* Steel blue color for headings */
  }
  
  .error-message {
    color: red;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
  }

  .employee-avatar {
    width: 40px;
    height: 40px;
    background-color: #007bff;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  .card {
    transition: transform 0.2s;
  }

  .card:hover {
    transform: translateY(-5px);
  }

  /* Custom tab styling */
  .nav-tabs .nav-link {
    color: #6c757d;
  }

  .nav-tabs .nav-link.active {
    color: #007bff;
    font-weight: 500;
  }

  /* Table responsiveness */
  .table-responsive {
    margin-top: 1rem;
  }

  /* Badge styling */
  .badge {
    font-weight: 500;
    padding: 0.5em 0.8em;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/hoteldetails/HotelDetails.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,YAAY;IACZ,yBAAyB,EAAE,+BAA+B;IAC1D,mBAAmB;IACnB,0BAA0B;IAC1B,wCAAwC;IACxC,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc,EAAE,gCAAgC;IAChD,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,yBAAyB,EAAE,oCAAoC;IAC/D,mBAAmB;IACnB,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc,EAAE,kCAAkC;EACpD;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,uBAAuB;EACvB;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,gBAAgB;IAChB,oBAAoB;EACtB","sourcesContent":[".hotel-details-container {\n   \n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n  }\n  \n  .hotel-card {\n    border: none;\n    background-color: #daffcd; /* Light color for hotel card */\n    border-radius: 10px;\n    transition: transform 0.3s;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-size: 18px;\n  }\n  \n  .hotel-card:hover {\n    /* transform: scale(1.03); */\n  }\n  \n  .hotel-title {\n    color: #8b4513; /* Brown color for hotel title */\n    font-weight: bold;\n  }\n  \n  .room-card {\n    border: none;\n    background-color: #ffe4e1; /* Light pink color for room cards */\n    border-radius: 10px;\n    transition: transform 0.3s;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .room-card:hover {\n    transform: scale(1.03);\n  }\n  \n  h2 {\n    color: #4682b4; /* Steel blue color for headings */\n  }\n  \n  .error-message {\n    color: red;\n    text-align: center;\n    margin-top: 20px;\n    font-weight: bold;\n  }\n\n  .employee-avatar {\n    width: 40px;\n    height: 40px;\n    background-color: #007bff;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n  }\n\n  .card {\n    transition: transform 0.2s;\n  }\n\n  .card:hover {\n    transform: translateY(-5px);\n  }\n\n  /* Custom tab styling */\n  .nav-tabs .nav-link {\n    color: #6c757d;\n  }\n\n  .nav-tabs .nav-link.active {\n    color: #007bff;\n    font-weight: 500;\n  }\n\n  /* Table responsiveness */\n  .table-responsive {\n    margin-top: 1rem;\n  }\n\n  /* Badge styling */\n  .badge {\n    font-weight: 500;\n    padding: 0.5em 0.8em;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
